import { useTranslation } from "react-i18next"
import { CapabilitiesMarketplaceResponseDataSchema, CapabilitiesResponseDataSchema } from "schema"
import z from "zod"
import { formatMissingRequirements } from "../lib/formatMissingRequirements"

type Capability = z.infer<typeof CapabilitiesResponseDataSchema>[number]
type MarketplaceCapability = z.infer<typeof CapabilitiesMarketplaceResponseDataSchema>[number]

type UseCapabilityActionsReturn = {
  canInstall: boolean
  canUninstall: boolean
  installDisabledReason: string | null
  uninstallDisabledReason: string | null
}

export function useCapabilityActions(
  capability: Capability | MarketplaceCapability,
): UseCapabilityActionsReturn {
  const { t } = useTranslation()

  const canInstall = "canBeInstalled" in capability ? capability.canBeInstalled.result : true
  const canUninstall = "canBeUninstalled" in capability ? capability.canBeUninstalled.result : true

  const installDisabledReason =
    !canInstall &&
    "canBeInstalled" in capability &&
    "missingRequirements" in capability.canBeInstalled
      ? formatMissingRequirements(capability.canBeInstalled.missingRequirements, t)
      : null

  const uninstallDisabledReason =
    !canUninstall &&
    "canBeUninstalled" in capability &&
    "missingRequirements" in capability.canBeUninstalled
      ? formatMissingRequirements(capability.canBeUninstalled.missingRequirements, t)
      : null

  return {
    canInstall,
    canUninstall,
    installDisabledReason,
    uninstallDisabledReason,
  }
}
